
import { Button } from "@/components/ui/button";
import { useSupabase } from "@/hooks/useSupabase";
import { Link } from "react-router-dom";
import { User } from "lucide-react";

export const AuthNav = () => {
  const { user, isLoggedIn, signOut } = useSupabase();

  console.log("AuthNav rendering, user logged in:", isLoggedIn);

  if (!isLoggedIn) {
    return (
      <div className="flex items-center gap-4">
        <Link to="/login">
          <Button variant="ghost">Log in</Button>
        </Link>
        <Link to="/signup">
          <Button className="bg-gradient-to-r from-ai-indigo to-ai-purple">
            Sign up
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4">
      <Button variant="ghost" onClick={signOut}>
        Log out
      </Button>
    </div>
  );
};
